import DirectDebitFormContent from './DirectDebitFormContent'

export default DirectDebitFormContent
